module.exports = __webpack_public_path__ + "static/media/ear-muffs.78ff34a5.svg";